import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {FourByFourOilDistributorReplacementGroup} from '../../kit/groups/FourByFourOilDistributorReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function FourByFourOilDistributorReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="four-by-four-oil-distributor-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.fourByFourOilDistributor')}</Heading>
          <VFKit.Group columns={4} data-testid="four-by-four-oil-distributor-replacement-group">
            <FourByFourOilDistributorReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
